<button class="help-button" mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
  <mat-icon>help</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <a mat-menu-item href="https://turnerhelp.tcco.com/assystnet/application.jsp#services" target="_blank">Create Service Desk Ticket</a>
  <a mat-menu-item href="https://tcco.sharepoint.com/sites/lean/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Flean%2FShared%20Documents%2F2023%2E02%2E03%20Lean%20Dashboard%20and%20Roadmap%20Guide%2Epdf&parent=%2Fsites%2Flean%2FShared%20Documents" target="_blank">User Guide</a>
</mat-menu>
